import React from "react";

import ActionSelector from "./ActionSelector";
import RoleSelector from "./RoleSelector";
import ResourceScopeEditor from "./ResourceScopeEditor";
import ConditionEditor from "./ConditionEditor";

import {
  POLICY_EFFECTS
} from "../constants/enums";

export default function PolicyForm({
  policy,
  onChange,
  readOnlyName = false
}) {

  const updateField = (field, value) => {

    onChange({
      ...policy,
      [field]: value
    });

  };

  return (
    <>

      {/* Policy Name */}
      <div className="form-group">
        <label>Policy Name</label>
        <input
          className="form-input"
          placeholder="e.g. payment_card_admin_policy"
          value={policy.policyName || ""}
          disabled={readOnlyName}
          onChange={(e) =>
            updateField(
              "policyName",
              e.target.value
            )
          }
        />
        <span className="input-hint" style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
          Unique identifier for this policy rule (e.g. support_masked_view_v1)
        </span>
      </div>

      {/* Description */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          className="form-input"
          placeholder="e.g. Grants full detokenization permission to payment processing services"
          value={policy.policyDescription || ""}
          onChange={(e) =>
            updateField(
              "policyDescription",
              e.target.value
            )
          }
        />
        <span className="input-hint" style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
          Explains the business or compliance justification to auditors
        </span>
      </div>

      {/* Priority */}
      <div className="form-group">
        <label>Priority</label>
        <input
          type="number"
          className="form-input"
          placeholder="e.g. 100"
          value={policy.priority}
          onChange={(e) =>
            updateField(
              "priority",
              Number(e.target.value)
            )
          }
        />
        <span className="input-hint" style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
          Evaluation precedence (Higher numbers evaluate first; e.g. 100 precedes 10)
        </span>
      </div>

      {/* Effect */}
      <div className="form-group">
        <label>Effect</label>
        <select
          className="form-input"
          value={policy.effect}
          onChange={(e) =>
            updateField(
              "effect",
              e.target.value
            )
          }
        >
          {POLICY_EFFECTS.map(effect => (
            <option
              key={effect}
              value={effect}
            >
              {effect}
            </option>
          ))}
        </select>
        <span className="input-hint" style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
          ALLOW grants access; DENY explicitly overrides any matching allows
        </span>
      </div>

      {/* Effective From */}
      <div className="form-group">
        <label>Effective From</label>
        <input
          type="datetime-local"
          className="form-input"
          value={
            policy.effectiveFrom
              ? policy.effectiveFrom.substring(0, 16)
              : ""
          }
          onChange={(e) =>
            updateField(
              "effectiveFrom",
              new Date(
                e.target.value
              ).toISOString()
            )
          }
        />
      </div>

      {/* Effective To */}
      <div className="form-group">
        <label>Effective To</label>
        <input
          type="datetime-local"
          className="form-input"
          value={
            policy.effectiveTo
              ? policy.effectiveTo.substring(0, 16)
              : ""
          }
          onChange={(e) =>
            updateField(
              "effectiveTo",
              e.target.value
                ? new Date(
                    e.target.value
                  ).toISOString()
                : null
            )
          }
        />
        <span className="input-hint" style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
          Optional: Specify an active validity date window, or leave blank for permanent enforcement
        </span>
      </div>


      {/* Actions */}

            <div className="form-section">

            <h3>Actions</h3>

            <ActionSelector
                actions={policy.actions}
                onChange={(actions) =>
                updateField("actions", actions)
                }
            />

            </div>


      {/* Roles */}

            <div className="form-section">

            <h3>Roles</h3>

            <RoleSelector
                roles={policy.roles}
                onChange={(roles) =>
                updateField("roles", roles)
                }
            />

            </div>


      {/* Resource Scope */}
        <div className="form-section">

        <h3>Resource Scope</h3>

        <ResourceScopeEditor
            resourceScope={policy.resourceScope}
            onChange={(scope) =>
            updateField("resourceScope", scope)
            }
        />

        </div>


      {/* Conditions */}

            <div className="form-section">

            <h3>Conditions</h3>

            <ConditionEditor
                conditions={policy.conditions}
                onChange={(conditions) =>
                updateField("conditions", conditions)
                }
            />

            </div>

    </>
  );
}